import React, { useState } from 'react';
import { Button } from 'reactstrap';
import { FormattedMessage } from 'react-intl';

import cardBrand from './cardBrand.json';
import PropTypes from 'prop-types';
import { FaChevronRight } from 'react-icons/fa';
import Modal from '../../Modals';
import { checkImageExists, getImagePath } from '../../../utils';

const hideDocument = (str) => {
  const asterisks = str.substring(0, str.length - 4).replace(/[0-9]/g, '*');
  return `${asterisks}${str.substring(str.length - 4, str.length)}`;
}

const types = {
  CARD: (paymentMethod) => ({
    id: paymentMethod.methodInfo.brand,
    title: cardBrand[paymentMethod.methodInfo.brand] || paymentMethod.methodInfo.brand,
    subtitle: paymentMethod.methodInfo.last4,
    secondLine: paymentMethod.methodInfo.expiration_month + '/' + paymentMethod.methodInfo.expiration_year
  }),
  BANK_TRANSFER: (paymentMethod) => ({
    id: paymentMethod.methodInfo.paymentMethodId,
    title: paymentMethod.methodInfo.paymentMethodId,
    subtitle: paymentMethod.payer.name,
    secondLine: hideDocument(paymentMethod.payer.document),
  }),
  TICKET: (paymentMethod) => ({
    id: paymentMethod.methodInfo.paymentMethodId,
    title: paymentMethod.methodInfo.paymentMethodId,
    subtitle: paymentMethod.payer.name,
    secondLine: hideDocument(paymentMethod.payer.document),
  })
}
const StripeItem = (props) => {
  const {
    item,
    paymentMethodsLength,
    changeFavorite,
    deletePaymentMethods,
    isSingleSubscriptionClient,
    activePlanPaymentData,
    validMethodsLength,
    isAValidMethod,
    client
  } = props;

  const type = item.methodInfo?.paymentMethodType || 'CARD';
  const countryCode = item.methodInfo?.country;
  const func = types[type];
  const payload = func(item);
  const isDisabledDeleteValidMethod = isSingleSubscriptionClient ? (validMethodsLength > 1 || !isAValidMethod) : true;
  const [modalFavoritePayment, setModalFavoritePayment] = useState(false);
  const [logoUrl, setLogoUrl] = useState(null);

  const isValidFavoritePaymentMethod = (activePlanPaymentData, item) => {
    const paymentMethodId = item.type === 'CARD' ? item.methodInfo?.brand : item.methodInfo?.paymentMethodId;
    return isSingleSubscriptionClient ? (activePlanPaymentData.subPaymentMethods[countryCode].includes(paymentMethodId)) : true;
  }

  checkImageExists(getImagePath(`${item.methodInfo?.brand}.png`, client), (exists) => {
    setLogoUrl(exists
      ? getImagePath(`${item.methodInfo?.brand}.png`, client)
      : getImagePath("card_placeholder.png", client));
  });

  return (
    <div className="paymentMethods_container">
      <div className="paymentMethods__items--imageDiv">
        <div
          style={{
            backgroundImage: `url(${logoUrl})`,
          }}
          className="paymentMethods__items--logo"
        />
      </div>
      <div className="paymentMethods__items--textDiv">
        <div className="paymentMethods__items--containerInformation">
          <div className="paymentMethods__items--information">
            <p className="paymentMethods__items--cardTitle">
              {payload.title} - {payload.subtitle}
            </p>
            {payload.secondLine && (
              <p className="paymentMethods__items--expireDate">
                <FormattedMessage
                  id={`MyAccount.paymentMethdos.${type}.secondLine`}
                />
                {payload.secondLine}
              </p>
            )}
            {item.default && (
              <p className="paymentMethods__items--defaultText">
                <FormattedMessage id="MyAccount.paymentMethdos.default" />
              </p>
            )}
            {item.disabled && (
              <p className="paymentMethods__items--boldText">
                <FormattedMessage id="MyAccount.paymentMethdos.disabledByProduct" />
              </p>
            )}
          </div>
        </div>
      </div>
      {!changeFavorite && (
        <div className="paymentMethods__items--actionContainer arrow__pay">
          <>
            <FaChevronRight color="#FFFFFF" size={20} />
          </>
        </div>
      )}
      {changeFavorite &&
        <div className="paymentMethods__items--actionContainer">
          {isValidFavoritePaymentMethod(activePlanPaymentData, item) && (
            <>
              {item.default ? (
                <Button
                  size="sm"
                  outline
                  color="link"
                  className="paymentMethods_button_favorite payment-method--favorite"
                >★
                </Button>
              ) : (
                <Button
                  onClick={() => setModalFavoritePayment(true)}
                  size="sm"
                  outline
                  color="link"
                  className="paymentMethods_button_favorite"
                >☆
                </Button>
              )}
            </>
          )}
          <div className="paymentMethods_container__buttons">
            {(deletePaymentMethods && paymentMethodsLength > 1 && isDisabledDeleteValidMethod) && (
              <Button
                size="sm"
                color="link"
                className="paymentMethods__items--deleteButton"
                onClick={() => deletePaymentMethods(item.paymentMethod, item._id, item.default)}
              >
                <FormattedMessage id="MyAccount.paymentMethdos.delete" />
              </Button>
            )}
          </div>
        </div>
      }
        <Modal
          title={
            <FormattedMessage id="MyAccount.paymentMethdos.favorite.title" />
          }
          isOpenModal={modalFavoritePayment}
          onToggleModal={() => setModalFavoritePayment(false)}
          description={
            <FormattedMessage id="MyAccount.paymentMethdos.favorite.description" />
          }
          secondaryButton={{
            text: <FormattedMessage id="MyAccount.paymentMethdos.favorite.change" />,
            onClick: () => {
              changeFavorite(item.paymentMethod, item._id);
              setModalFavoritePayment(false);
            },
          }}
          primaryButton={{
            text: <FormattedMessage id="MyAccount.paymentMethdos.favorite.cancel" />,
            onClick: () => {
              setModalFavoritePayment(false);
            },
          }}
        />
    </div>
  )
}

const items = {
  stripe: StripeItem
}
const PaymentMethodItem = (props) => {
  const { item } = props;

  const Item = items[item.paymentMethod];

  const onClick = (e) => {
    e.stopPropagation();
    if (props.selectPaymentMethod) {
      props.selectPaymentMethod(props.item);
    }
  }

  const style = {};
  if (props.selectPaymentMethod) {
    style.cursor = 'pointer';
    if (item.disabled) {
      style.pointerEvents = 'none';
    }
  }
  
  if (!Item) {
    return <></>
  }

  return (
    <div
      onClick={onClick}
      style={style}
      className={item.disabled
        ? 'paymentMethods__items--disabled'
        : 'paymentMethods__items'}
    >
      <Item {...props} />
    </div>
  );
}

PaymentMethodItem.propTypes = {
  selectPaymentMethod: PropTypes.func,
  item: PropTypes.shape({
    disabled: PropTypes.bool,
    paymentMethod: PropTypes.string.isRequired,
  })
}

StripeItem.propTypes = {
  paymentMethodsLength: PropTypes.number.isRequired,
  deletePaymentMethods: PropTypes.func,
  isSingleSubscriptionClient: PropTypes.bool,
  activePlanPaymentData: PropTypes.object,
  validMethodsLength: PropTypes.number,
  isAValidMethod: PropTypes.bool,
  changeFavorite: PropTypes.func,
  item: PropTypes.shape({
    _id: PropTypes.string.isRequired,
    type: PropTypes.string,
    methodInfo: PropTypes.object.isRequired,
    disabled: PropTypes.bool,
    default: PropTypes.bool.isRequired,
    paymentMethod: PropTypes.string.isRequired,
    brand: PropTypes.string,
  }).isRequired
}
export default PaymentMethodItem;
